const resolveMatrixAns = (ans = {}) => {
  let parsedAns = "";
  Object.keys(ans).forEach((key) => {
    parsedAns += `${key} : ${ans[key] || ""} , `;
  });
  return parsedAns.slice(0, -1);
};
export default resolveMatrixAns;
